import React from "react";
import { FormattedMessage } from "react-intl";
import LoadingArea from "theme/components/molecules/LoadingArea";

const MiniCartContentLoading = () => {
  return (
    <div className="page-content">
      <LoadingArea appearance="center">
        <FormattedMessage
          id="modules.Cart.MiniCart.MiniCartContent.loading"
          defaultMessage="Loading cart..."
        />
      </LoadingArea>
    </div>
  );
};

export default MiniCartContentLoading;
